import React from 'react';

import Button from '@atlaskit/button/standard-button';
import DropdownMenu, {
  DropdownItem,
  DropdownItemGroup,
} from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';

import { useTestCaseRepositoryFoldersContext } from '../../TestCaseRepositoryFoldersProvider';
import { useTestCaseRepositoryModalsContext } from '../../TestCaseRepositoryModalsProvider';
import { TextDangerStyled } from './FolderMenuDropdown.styled';

export function FolderMenuDropdown(): JSX.Element {
  const { openDeleteFolderModal } = useTestCaseRepositoryModalsContext();
  const { currentFolder } = useTestCaseRepositoryFoldersContext();

  if (!currentFolder.canEdit) {
    return null;
  }

  return (
    <DropdownMenu
      placement='bottom-end'
      trigger={({ triggerRef, ...props }) => (
        <Button
          {...props}
          iconBefore={
            <MoreIcon
              label='Folder actions'
              primaryColor='var(--ds-icon, var(--ds-fb-icon))'
            />
          }
          ref={triggerRef}
          appearance='default'
          testId='folder-dropdown-button'
        />
      )}
    >
      <DropdownItemGroup title='FOLDER'>
        <DropdownItem
          key='deleteFolder'
          onClick={() => openDeleteFolderModal({ folder: currentFolder })}
        >
          <TextDangerStyled>Delete folder</TextDangerStyled>
        </DropdownItem>
      </DropdownItemGroup>
    </DropdownMenu>
  );
}
